<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-group">
        <div class="group-one">
          <a-select
              v-model:value="searchForm.type"
              placeholder="类型"
              @change="updateChange"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">区域</a-select-option>
            <a-select-option :value="2">民族</a-select-option>
            <a-select-option :value="3">用户ID</a-select-option>
            <a-select-option :value="4">证件号</a-select-option>
            <a-select-option :value="5">公安协查</a-select-option>
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.status"
              placeholder="状态"
              @change="updateChange"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.content"
            :loading="searchLoading"
            placeholder="内容"
            @search="getTableData"
        >
        </a-input-search>
      </div>
      <div class="lef-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one" @click="handleOpenModal">
        <a-button class="btn-primary">添加黑名单</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'status'">
        <span v-if="record.status == 0" class="f-c-red">{{ record.status_text }}</span>
        <span v-else>{{ record.status_text }}</span>
      </template>
      <template v-if="column.key == 'operation'">
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
        <a-button danger type="link" @click="handleDel(record)">删除</a-button>
      </template>
    </template>
  </a-table>

  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :title="modalTitle"
      :width="600"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="类型：" name="type">
        <a-select
            v-model:value="addForm.type"
            placeholder="请选择"
            @change="handleChange"
        >
          <a-select-option :value="1">区域</a-select-option>
          <a-select-option :value="2">民族</a-select-option>
          <a-select-option :value="3">用户ID</a-select-option>
          <a-select-option :value="4">证件号</a-select-option>
          <a-select-option :value="5">公安协查</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="内容：" name="content">
        <a-input
            v-model:value="addForm.content"
            :maxlength="50"
            :placeholder="modalMsg"
            allowClear show-count
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="备注说明：" name="remark">
        <a-textarea
            v-model:value="addForm.remark"
            :maxlength="255"
            allowClear placeholder="请输入处理备注信息"
            show-count
            style="width: 100%"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="是否启用：" name="status">
        <a-switch v-model:checked="addForm.status" checked-children="开" un-checked-children="关"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {blackAdd, blackDel, blackEdit, blackList,} from "@/api/api";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import {message, Modal} from "ant-design-vue";

export default {
  components: {},
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        type: [],
        start: 0,
        limit: 20,
        content: '',
        status: [],
      },
      // 更新查询
      updateChange() {
        table.getTableData();
      },
      // 重置搜索
      handleReset() {
        search.searchForm.type = [];
        search.searchForm.status = [];
        search.searchForm.content = '';
        search.searchForm.start = 0;
        search.searchForm.limit = 20;
        search.updateChange();
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "类型",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "内容",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "标题",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "备注说明",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
        },
        {
          title: "添加时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          align: "center",
        },
      ],
      getTableData() {
        search.searchLoading = true;
        blackList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      handleDel(item) {
        Modal.confirm({
          title: `是否删除？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            blackDel({id: item.id}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      handleEdit(item) {
        modal.modalTitle = "修改服务";
        nextTick(() => {
          modal.addForm.type = item.type;
          modal.addForm.content = item.content;
          modal.addForm.remark = item.remark;
          modal.addForm.status = item.status == 1 ? true : false;
          modal.addForm.id = item.id;
        });
        modal.visibleAdd = true;
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      modalMsg: "请选择类型",
      handleOpenModal() {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.modalTitle = "添加名单";
        modal.visibleAdd = true;
      },
      formRef: "", //表单验证
      addForm: {
        type: [],
        status: true,
        content: '',
        remark: '',
        id: '',
      },
      rules: {
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.isLoading = true;
          if (modal.modalTitle == '添加名单') {
            blackAdd(modal.addForm)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          } else {
            blackEdit(modal.addForm)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          }
        });
      },
      handleChange(item) {
        console.log(item)
        if (item == 1) {
          modal.modalMsg = "请输入身份证号前6位数字或标准区域编码";
        }
        if (item == 2) {
          modal.modalMsg = "请输入民族名称";
        }
        if (item == 3) {
          modal.modalMsg = "请输入用户在系统中的用户ID";
        }
        if (item == 4) {
          modal.modalMsg = "请输入用户的证件号";
        }
        if (item == 5) {
          modal.modalMsg = "请输入协查的证件号";
        }
      }
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .QR {
  }

  .info {
    font-weight: bold;
  }

  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
